<script lang="ts">
    import {_, time} from 'svelte-i18n'
    import type {Conversation, Message, Session} from './types';
    import {Role} from './types';
    import Autoscroll from './Autoscroll.svelte';
    import ConversationMessage from './ConversationMessage.svelte';

    export let session: Session;
    export let conversation: Conversation;
    export let messages: Message[];

</script>


<Autoscroll>
    <div class="conversation-messages">
        {#if conversation.createDate}
            <div class="message-row informative-message-row">
                <div class="informative-message informative-message-conversation-created">
                    {$_('chat.Created')} {$time(conversation.createDate, {format: 'short'})}
                </div>
            </div>
        {/if}
        {#if conversation.startDate}
            <div class="message-row informative-message-row">
                <div class="informative-message informative-message-conversation-started">
                    {$_('chat.Started')} {$time(conversation.startDate, {format: 'short'})}
                </div>
            </div>
        {/if}
        {#each messages as message (message.id)}
            <div class="message-row card-container">
                <ConversationMessage message={message} />
            </div>
        {/each}
        {#if conversation.pauseDate}
            <div class="message-row informative-message-row">
                <div class="informative-message informative-message-conversation-paused">
                    {#if session.roles.includes(Role.OPERATOR)}
                        {$_('chat.ChatSuspendedContinueWithContinueButton')}
                    {:else}
                        {$_('chat.ConsultantSuspendedChatWaitPlease')}
                    {/if}
                </div>
            </div>
        {/if}
        {#if conversation.endDate}
            <div class="message-row informative-message-row">
                <div class="informative-message informative-message-conversation-ended">
                    {$_('chat.Ended')} {$time(conversation.endDate, {format: 'short'})}
                </div>
            </div>
        {/if}
    </div>
</Autoscroll>


<style lang="scss">
  .conversation-messages {
    min-height: 100%;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background: #fff0f0;
  }

  .informative-message {
    color: gray;
  }
  .informative-message-conversation-created,
  .informative-message-conversation-started {
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
  .informative-message-conversation-paused,
  .informative-message-conversation-ended {
    margin-top: 10px;
    padding-top: 10px;
  }
  .informative-message-conversation-paused {
    color: #676767;
    text-align: center;
    font-weight: bold;
  }
</style>